#import "../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation EntityDocumentDistributionUpdate(
  $input: EntityDocumentDistributionUpdateInput!
) {
  entityDocumentDistributionUpdate(input: $input) {
    entityDocument {
      ...EntityDocumentsFields
      _resetAccountingAllowed
      _protectedWithAccountingUpdate
      extractionType {
        isExtractProtected
      }
      lookupName {
        lookupName
        id
        isApprovedVendor
        lookupCode
        lookupName
        lookupName2
        address1
        address2
        city
        state
        zipCode
        country
        phone
        emailAccount
      }
    }
  }
}
